import { X_Language, isAvailableForSale, isEmpty } from '@/utils';
import ThirdPartyPlatformConfig from '@/utils/configs/ThirdPartyPlatform.config';

/*
 *
 * @desc: 预计发货日期（当前勾选的产品 + 赠品），选取发货时间最长的一个展示
 * @param {object} commodities
 * @return {number}
 *
 */
const deliveryTimeHandler = (commodities = []) => {
  if (isEmpty(commodities)) return '';
  const canSaleCommodities = commodities.filter((o) => isAvailableForSale(o));
  const effectiveLength = canSaleCommodities.length;
  if (effectiveLength === 0) {
    return '';
  } else {
    if (effectiveLength === 1) {
      // 移除导流地区产品
      const redirectData = ThirdPartyPlatformConfig.getRedirectData({
        pid: canSaleCommodities[0]?.product,
        cid: canSaleCommodities[0]?.id,
      });
      if (redirectData?.url) return '';
    }
    try {
      let estimate_days = -1;
      commodities.forEach((o) => {
        const { delivery_time_config, bind_services } = o;
        if (delivery_time_config) {
          if (delivery_time_config.estimate_days > estimate_days) {
            estimate_days = delivery_time_config.estimate_days;
          }
          if (bind_services) {
            bind_services.forEach((s) => {
              if (s.delivery_time_config && s.delivery_time_config.estimate_days > estimate_days) {
                estimate_days = s.delivery_time_config.estimate_days;
              }
            });
          }
        }
      });
      return estimate_days;
    } catch (e) {
      console.error(e);
    }
  }
};

/*
 *
 * @desc: 预计发货日期（当前勾选的产品 + 赠品），选取发货时间最长的一个展示
 * @param {object} commodities
 * @param {boolean} isBussinessDay 文案中是否要带工作日
 * @param {boolean} hasFinishMark 是否要结束后的标点符号
 * @return {string} text
 * @author: haifn
 * @time:  2020/6/1 14:59
 *
 */
const deliveryTimeTextHandler = ({ commodities, LANG, isBussinessDay = false, hasFinishMark = false }) => {
  const estimate_days = deliveryTimeHandler(commodities);
  const mark = hasFinishMark ? (['zh_cn', 'zh_tw', 'ja_jp'].includes(X_Language?.toLowerCase()) ? '。 ' : '. ') : '';
  const deliveryDay = isBussinessDay
    ? LANG['common.label.deliveryTimeText_businessDays']
    : LANG['common.label.deliveryTimeText'];
  const l_text = deliveryDay?.split('&&')[0];
  const r_text = deliveryDay?.split('&&')[1];
  return estimate_days > 0 ? l_text + estimate_days + r_text + mark : '';
};

export { deliveryTimeTextHandler, deliveryTimeHandler };
